var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-160c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-160c-8.84 0-16 7.16-16 16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19l-209.14-151.08v213.14c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48v-213.14l-209.14 151.08c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81v-44.14c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56-16.81-12.27-50.21-41.79-73.41-41.44-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56h-77.55c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81a47.995 47.995 0 0 0 -18.39 37.77v10.65l96 69.35v-184.72h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.a0454a6129ac1b54e90789e435e6ee82.svg";
export { ForwardRef as ReactComponent };